export default class extends Controller {
  static targets = ["fileField"]

  connect() {
    this.fileFieldTarget.addEventListener("change", this.afterFileSelect.bind(this))
  }

  selectFiles(event) {
    if (event.target !== this.fileFieldTarget) {
      this.fileFieldTarget.click()
    }
  }

  afterFileSelect(event) {
    Array.from(this.fileFieldTarget.files).forEach((file => {
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      const fileID = Math.random().toString(36).slice(2) // random string for the form to use as an identifier
      dispatchCustomEvent("message--file-select", this.element, { dataTransfer, formID: this.formID, fileID })
    }).bind(this))
  }

  get formID() {
    return this.data.get("form-id")
  }
}



// WEBPACK FOOTER //
// ./app/components/messages/assets/javascript/messages-file-select-button-controller.js